import { useNavigate, useLocation } from "react-router-dom";
import { GitBranch, Users, Activity, Heart, Settings } from "lucide-react";
import { cn } from "@/lib/utils";
import { ROUTES } from "@/lib/routes";

export function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { icon: GitBranch, label: "Signals", path: ROUTES.WORKFLOWS },
    { icon: Users, label: "Squad", path: ROUTES.SQUAD },
    { icon: Activity, label: "Performance", path: ROUTES.PERFORMANCE },
    { icon: Heart, label: "Medical", path: ROUTES.WELLNESS },
    { icon: Settings, label: "Admin", path: ROUTES.SETTINGS },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-lg safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            location.pathname.startsWith(item.path + "/");
          const Icon = item.icon;

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={cn(
                "flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors",
                "active:bg-muted/50",
                isActive ? "text-primary" : "text-muted-foreground"
              )}
            >
              <Icon className={cn("h-5 w-5", isActive && "animate-scale-in")} />
              <span className="text-[10px] font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
